var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _g, _g2, _g3, _path2, _path3, _path4, _path5, _path6, _path7, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_17917",
    "data-name": "Group 17917",
    xmlns: "http://www.w3.org/2000/svg",
    width: 673.988,
    height: 377.267,
    viewBox: "0 0 673.988 377.267",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M31.759,173.566V128.954H58.577v44.611H90.336V104.558h23.29V52.976H132.68V0H172.2V52.976h19.055v51.582h22.584V42.52h12.7V11.153h7.763V42.52h45.168V240.483h34.582V219.571H335.23v20.912h34.582V173.566h62.106V128.954h26.818v44.611h1.411V259.3h28.23V209.115h33.876V259.3h28.23V104.558H572.36V52.976h80.455v51.582h21.172V377.1H0V173.566Z",
    transform: "translate(0)",
    fill: "#242b41"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 29.45,
    height: 16.829,
    transform: "translate(631.215 123.037)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 29.45,
    height: 16.829,
    transform: "translate(564.28 123.037)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 29.45,
    height: 16.829,
    transform: "translate(631.215 156.463)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 29.45,
    height: 16.829,
    transform: "translate(564.28 156.463)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 29.45,
    height: 16.829,
    transform: "translate(631.215 189.89)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 29.45,
    height: 16.829,
    transform: "translate(564.28 189.89)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 29.45,
    height: 16.829,
    transform: "translate(631.215 223.316)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 29.45,
    height: 16.829,
    transform: "translate(564.28 223.316)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 29.45,
    height: 16.829,
    transform: "translate(631.215 256.742)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 29.45,
    height: 16.829,
    transform: "translate(564.28 256.742)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 29.45,
    height: 16.829,
    transform: "translate(631.215 290.168)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 29.45,
    height: 16.829,
    transform: "translate(564.28 290.168)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 29.45,
    height: 16.829,
    transform: "translate(631.215 323.366)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 29.45,
    height: 16.829,
    transform: "translate(564.28 323.366)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 68.717,
    height: 8.414,
    transform: "translate(470.625 281.565)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 68.717,
    height: 8.414,
    transform: "translate(470.625 294.363)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 68.717,
    height: 8.414,
    transform: "translate(470.625 306.787)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 68.717,
    height: 8.414,
    transform: "translate(289.995 285.831)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    width: 68.717,
    height: 8.414,
    transform: "translate(289.995 298.629)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 68.717,
    height: 8.414,
    transform: "translate(289.995 311.079)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    width: 68.717,
    height: 8.414,
    transform: "translate(470.625 319.663)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    width: 68.717,
    height: 8.414,
    transform: "translate(470.625 332.54)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    "data-name": "Rectangle 37",
    width: 68.717,
    height: 8.414,
    transform: "translate(470.625 345.416)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 18.932,
    height: 24.542,
    transform: "translate(425.996 193.491)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    width: 18.932,
    height: 24.542,
    transform: "translate(384.384 193.491)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 18.932,
    height: 24.542,
    transform: "translate(425.996 233.327)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    width: 18.932,
    height: 24.542,
    transform: "translate(384.384 233.327)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    "data-name": "Rectangle 42",
    width: 18.932,
    height: 24.542,
    transform: "translate(425.996 273.163)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    width: 18.932,
    height: 24.542,
    transform: "translate(384.384 273.163)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44",
    "data-name": "Rectangle 44",
    width: 18.932,
    height: 24.542,
    transform: "translate(425.996 312.748)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45",
    "data-name": "Rectangle 45",
    width: 18.932,
    height: 24.542,
    transform: "translate(384.384 312.748)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    "data-name": "Rectangle 46",
    width: 25.243,
    height: 32.255,
    transform: "translate(253.917 58.52)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    width: 25.243,
    height: 32.255,
    transform: "translate(253.917 106.73)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48",
    "data-name": "Rectangle 48",
    width: 25.243,
    height: 32.255,
    transform: "translate(253.917 153.691)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    width: 25.243,
    height: 32.255,
    transform: "translate(253.917 200.652)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 25.243,
    height: 32.255,
    transform: "translate(253.917 247.614)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    width: 25.243,
    height: 32.255,
    transform: "translate(253.917 294.248)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    width: 93.961,
    height: 27.347,
    transform: "translate(104.128 126.633)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    width: 93.961,
    height: 27.347,
    transform: "translate(103.778 186.393)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    width: 93.961,
    height: 27.347,
    transform: "translate(103.426 246.153)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    width: 93.961,
    height: 27.347,
    transform: "translate(103.076 305.631)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    width: 12.622,
    height: 26.646,
    transform: "translate(640.331 69.007)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 31.554,
    height: 40.669,
    transform: "translate(0 193.589)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 31.554,
    height: 40.669,
    transform: "translate(0 253.374)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 31.554,
    height: 40.669,
    transform: "translate(0 313.004)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(173.084 233.186)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M185.368,585.469s34.109,20.579-28.767,52.262c0,0-13.864-25.717,1.464-46.687a20.649,20.649,0,0,1,26.787-5.87Z",
    transform: "translate(-127.733 -495.102)",
    fill: "#01a09b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M201.47,588.3S172.282,610.634,173.1,641",
    transform: "translate(-144.711 -498.367)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M240.251,561.074s10.688-36.289-2.006-63a57.3,57.3,0,0,1-4.636-35.959,96.4,96.4,0,0,1,5.091-16.9",
    transform: "translate(-213.585 -417.276)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M226.815,395.529c0,4.449,8.054,17.33,8.054,17.33s8.054-12.9,8.054-17.33a8.054,8.054,0,1,0-16.1,0Z",
    transform: "translate(-209.571 -387.289)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M258.587,447.125c2.417,3.734,16.186,10.181,16.186,10.181s-.251-15.2-2.669-18.937a8.054,8.054,0,0,0-13.517,8.752Z",
    transform: "translate(-254.749 -413.838)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M253.734,540.4c3.973,2,19.11.62,19.11.62s-7.889-13-11.862-15a8.053,8.053,0,1,0-7.253,14.381Z",
    transform: "translate(-249.3 -464.26)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M235.865,614.623c3.574,2.643,18.734,3.839,18.734,3.839s-5.58-14.141-9.154-16.788a8.054,8.054,0,1,0-9.579,12.95Z",
    transform: "translate(-223.773 -506.015)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M230.475,470.388c-3.189,3.1-18.053,6.308-18.053,6.308s3.639-14.761,6.828-17.863a8.054,8.054,0,1,1,11.221,11.55Z",
    transform: "translate(-193.431 -425.884)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M207.786,554.687c-3.973,2-19.11.619-19.11.619s7.889-13,11.862-15a8.053,8.053,0,1,1,7.253,14.381Z",
    transform: "translate(-162.254 -472.228)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M202.647,641.783c-3.574,2.643-18.734,3.838-18.734,3.838s5.58-14.145,9.159-16.788a8.054,8.054,0,1,1,9.579,12.95Z",
    transform: "translate(-153.873 -520.444)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M226.815,395.529c0,4.449,8.054,17.33,8.054,17.33s8.054-12.9,8.054-17.33a8.054,8.054,0,1,0-16.1,0Z",
    transform: "translate(-209.571 -387.289)",
    fill: "#93d502",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M258.587,447.125c2.417,3.734,16.186,10.181,16.186,10.181s-.251-15.2-2.669-18.937a8.054,8.054,0,0,0-13.517,8.752Z",
    transform: "translate(-254.749 -413.838)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M253.734,540.4c3.973,2,19.11.62,19.11.62s-7.889-13-11.862-15a8.053,8.053,0,1,0-7.253,14.381Z",
    transform: "translate(-249.3 -464.26)",
    fill: "#93d502",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M235.865,614.623c3.574,2.643,18.734,3.839,18.734,3.839s-5.58-14.141-9.154-16.788a8.054,8.054,0,1,0-9.579,12.95Z",
    transform: "translate(-223.773 -506.015)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M230.475,470.388c-3.189,3.1-18.053,6.308-18.053,6.308s3.639-14.761,6.828-17.863a8.054,8.054,0,1,1,11.221,11.55Z",
    transform: "translate(-193.431 -425.884)",
    fill: "#5ec5c1",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M207.786,554.687c-3.973,2-19.11.619-19.11.619s7.889-13,11.862-15a8.053,8.053,0,1,1,7.253,14.381Z",
    transform: "translate(-162.254 -472.228)",
    fill: "#93d502",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M202.647,641.783c-3.574,2.643-18.734,3.838-18.734,3.838s5.58-14.145,9.159-16.788a8.054,8.054,0,1,1,9.579,12.95Z",
    transform: "translate(-153.873 -520.444)",
    opacity: 0.25
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(14.22 184.703)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M1012.894,578.286s14.271-48.455-2.679-84.119a76.515,76.515,0,0,1-6.19-48.015,128.721,128.721,0,0,1,6.8-22.561",
    transform: "translate(-977.36 -386.005)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M996.9,376.663c0,5.941,10.754,23.14,10.754,23.14s10.754-17.222,10.754-23.14a10.754,10.754,0,1,0-21.5,0Z",
    transform: "translate(-973.988 -365.66)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M1029.327,429.277c3.228,4.987,21.613,13.595,21.613,13.595s-.336-20.3-3.564-25.286a10.754,10.754,0,1,0-18.049,11.686Z",
    transform: "translate(-1024.182 -384.833)",
    fill: "#5ec5c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M1025.281,523.878c5.305,2.673,25.518.827,25.518.827s-10.534-17.355-15.839-20.028a10.753,10.753,0,1,0-9.685,19.2Z",
    transform: "translate(-1019.36 -422.206)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M1007.019,597.864c4.773,3.529,25.014,5.125,25.014,5.125s-7.451-18.882-12.224-22.417a10.754,10.754,0,1,0-12.791,17.292Z",
    transform: "translate(-990.935 -452.836)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M1006.889,453.543c-4.258,4.136-24.106,8.423-24.106,8.423s4.859-19.709,9.117-23.851a10.755,10.755,0,1,1,14.989,15.428Z",
    transform: "translate(-957.552 -394.129)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M984.709,538.257c-5.3,2.673-25.518.827-25.518.827s10.535-17.355,15.84-20.028a10.754,10.754,0,0,1,9.678,19.2Z",
    transform: "translate(-924.138 -428.143)",
    fill: "#5ec5c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M978.988,625.024c-4.773,3.529-25.014,5.126-25.014,5.126s7.451-18.882,12.224-22.417a10.754,10.754,0,1,1,12.791,17.292Z",
    transform: "translate(-914.084 -463.951)",
    fill: "#017572"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(220.425 251.509)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M899.44,639.921s-9.3-31.554,1.746-54.792a49.85,49.85,0,0,0,4.032-31.273,83.841,83.841,0,0,0-4.425-14.676",
    transform: "translate(-877.687 -514.446)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M906.744,515.242c0,3.871-7.012,15.083-7.012,15.083s-7.012-11.219-7.012-15.083a7.012,7.012,0,1,1,14.024,0Z",
    transform: "translate(-876.772 -508.23)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M923.23,544.065c-2.1,3.247-14.08,8.856-14.08,8.856s.217-13.225,2.321-16.471a7.012,7.012,0,1,1,11.759,7.615Z",
    transform: "translate(-881.682 -515.294)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M921.425,595.407c-3.457,1.739-16.625.54-16.625.54s6.865-11.3,10.315-13.042a7.012,7.012,0,0,1,6.311,12.509Z",
    transform: "translate(-880.382 -529.403)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M912.116,635.089c-3.113,2.3-16.3,3.338-16.3,3.338s4.852-12.3,7.965-14.6a7.012,7.012,0,0,1,8.33,11.261Z",
    transform: "translate(-877.699 -539.386)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M887.171,557.266c2.8,2.693,15.7,5.49,15.7,5.49s-3.162-12.839-5.939-15.532a7.012,7.012,0,1,0-9.761,10.048Z",
    transform: "translate(-874.406 -518.746)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M876.19,603.1c3.457,1.739,16.625.54,16.625.54s-6.865-11.3-10.315-13.042a7.012,7.012,0,0,0-6.311,12.51Z",
    transform: "translate(-870.761 -531.59)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M872.6,649.681c3.113,2.3,16.3,3.338,16.3,3.338s-4.88-12.306-7.966-14.606a7.012,7.012,0,0,0-8.33,11.268Z",
    transform: "translate(-869.977 -543.734)",
    fill: "#017572"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M320.314,154.551h4.824a3.38,3.38,0,1,1,0-6.753h39.078a3.38,3.38,0,0,1,0,6.753h-4.824a3.38,3.38,0,1,1,0,6.753h6.753a3.38,3.38,0,1,1,0,6.753H327.067a3.38,3.38,0,1,1,0-6.753h-6.753a3.38,3.38,0,1,1,0-6.753Z",
    transform: "translate(166.676 -121.118)",
    fill: "#ebfaff",
    opacity: 0.099
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29-2",
    "data-name": "Path 29",
    d: "M566.314,275.551h4.824a3.38,3.38,0,1,1,0-6.753h39.078a3.38,3.38,0,0,1,0,6.753h-4.824a3.38,3.38,0,1,1,0,6.753h6.752a3.38,3.38,0,1,1,0,6.753H573.067a3.38,3.38,0,1,1,0-6.753h-6.753a3.38,3.38,0,1,1,0-6.753Z",
    transform: "translate(-252.874 -155.671)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_30-2",
    "data-name": "Path 30",
    d: "M985.314,117.551h4.824a3.38,3.38,0,1,1,0-6.753h39.078a3.38,3.38,0,0,1,0,6.753h-4.824a3.38,3.38,0,1,1,0,6.753h6.753a3.38,3.38,0,1,1,0,6.753H992.067a3.38,3.38,0,0,1,0-6.753h-6.753a3.38,3.38,0,1,1,0-6.753Z",
    transform: "translate(-967.56 -110.062)",
    fill: "#ebfaff",
    opacity: 0.099
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31-2",
    "data-name": "Path 31",
    d: "M518.88,465.94c.54.393.834.61.834.61A3.551,3.551,0,0,1,518.88,465.94Z",
    transform: "translate(-125.784 -212.737)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32-2",
    "data-name": "Path 32",
    d: "M519.81,466.88c.54.393.835.61.835.61A3.561,3.561,0,0,1,519.81,466.88Z",
    transform: "translate(-127.369 -213.009)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_33-2",
    "data-name": "Path 33",
    d: "M519.81,465.94c.54.393.835.61.835.61A3.556,3.556,0,0,1,519.81,465.94Z",
    transform: "translate(-127.369 -212.737)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(79.079 246.981)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46-2",
    "data-name": "Path 46",
    d: "M1006.367,528.181s-9.649-32.761,1.811-56.874a51.731,51.731,0,0,0,4.185-32.464,87.039,87.039,0,0,0-4.6-15.254",
    transform: "translate(-983.562 -398.178)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47-2",
    "data-name": "Path 47",
    d: "M1011.449,373.1c0,4.017-7.271,15.645-7.271,15.645s-7.271-11.644-7.271-15.645a7.271,7.271,0,1,1,14.538,0Z",
    transform: "translate(-980.113 -365.66)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48-2",
    "data-name": "Path 48",
    d: "M1042.063,423.827c-2.182,3.372-14.613,9.192-14.613,9.192s.227-13.725,2.409-17.1a7.271,7.271,0,1,1,12.2,7.9Z",
    transform: "translate(-998.711 -393.777)",
    fill: "#5ec5c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49-2",
    "data-name": "Path 49",
    d: "M1036.612,517.285c-3.587,1.807-17.253.559-17.253.559s7.122-11.734,10.709-13.541a7.27,7.27,0,1,1,6.548,12.983Z",
    transform: "translate(-993.785 -448.543)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50-2",
    "data-name": "Path 50",
    d: "M1019.572,591.581c-3.227,2.386-16.912,3.465-16.912,3.465s5.038-12.766,8.264-15.156a7.271,7.271,0,1,1,8.648,11.691Z",
    transform: "translate(-983.617 -493.526)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51-2",
    "data-name": "Path 51",
    d: "M984.988,447.561c2.879,2.8,16.3,5.695,16.3,5.695S998,439.93,995.122,437.129a7.272,7.272,0,1,0-10.134,10.431Z",
    transform: "translate(-971.515 -407.39)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52-2",
    "data-name": "Path 52",
    d: "M963.028,531.7c3.587,1.807,17.252.559,17.252.559s-7.122-11.734-10.709-13.541a7.271,7.271,0,0,0-6.543,12.982Z",
    transform: "translate(-957.151 -457.254)",
    fill: "#5ec5c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53-2",
    "data-name": "Path 53",
    d: "M956.922,618.741c3.227,2.386,16.912,3.465,16.912,3.465s-5.038-12.766-8.265-15.156a7.271,7.271,0,1,0-8.648,11.691Z",
    transform: "translate(-953.974 -509.838)",
    fill: "#017572"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLeft);
export default __webpack_public_path__ + "static/media/footer-left.aaafb85d5145f21010691d47be3b70d4.svg";
export { ForwardRef as ReactComponent };